export enum OperationCode {
	CAR = 'CAR',
	TRUCK = 'TRU'
}
